/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { defineComponent, computed, createVNode } from 'vue';
import ColorSlider from './slider.mjs';
import { useBaseClassName } from '../hooks.mjs';
import '../../_chunks/dep-b011b919.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../const.mjs';
import '../../_common/js/color-picker/constants.mjs';
import '../utils/index.mjs';
import '../../_common/js/color-picker/index.mjs';
import '../../_common/js/color-picker/cmyk.mjs';
import '../../_common/js/color-picker/color.mjs';
import '../../_chunks/dep-fc63c737.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-d8a84e5f.mjs';
import '../../_chunks/dep-5db111ef.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-e00db566.mjs';
import '../../_common/js/color-picker/draggable.mjs';
import './base-props.mjs';
import '../../hooks/useConfig.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

var AlphaSlider = defineComponent({
  name: "AlphaSlider",
  inheritAttrs: false,
  props: {
    color: {
      type: Object
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    onChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  },
  setup: function setup(props) {
    var baseClassName = useBaseClassName();
    var handleChange = function handleChange(v, isDragEnd) {
      props.onChange(v / 100, isDragEnd);
    };
    var railStyle = computed(function () {
      return {
        background: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(props.color.rgb, ")")
      };
    });
    return {
      baseClassName: baseClassName,
      railStyle: railStyle,
      handleChange: handleChange
    };
  },
  render: function render() {
    var baseClassName = this.baseClassName;
    return createVNode(ColorSlider, {
      "class": ["".concat(baseClassName, "__alpha"), "".concat(baseClassName, "--bg-alpha")],
      "color": this.color,
      "value": this.color.alpha * 100,
      "onChange": this.handleChange,
      "rail-style": this.railStyle,
      "max-value": 100,
      "disabled": this.disabled,
      "type": "alpha"
    }, null);
  }
});

export { AlphaSlider as default };
//# sourceMappingURL=alpha.mjs.map
